/* import __COLOCATED_TEMPLATE__ from './documents-requested.hbs'; */
import Component from '@glimmer/component';
export default class DocumentsRequested extends Component {
  get informationRequestSSPUrl() {
    if (!this.args.sspRequestToken && this.args.requireSspRequestToken) {
      throw new Error('Invalid sspRequestToken');
    }
    // TODO(SFSP-3262): Use sspRequestToken in savings flow and remove this conditional
    if (!this.args.sspRequestToken) {
      return '/dashboard/business/information-requests';
    }
    return `/dashboard/business/information-requests/r/${this.args.sspRequestToken}`;
  }
}